import { generatePath } from "react-router-dom";

import type { IExtractParams } from "../types";

const availabilityTimeByIdPath = "/availability-time/:id";

export type IAvailabilityTimeByIdParams = IExtractParams<
  typeof availabilityTimeByIdPath,
  string
>;

export const path = {
  availabilityTime: {
    route: "/availability-time",
    link: () => path.availabilityTime.route,
  },
  availabilityTimeById: {
    route: availabilityTimeByIdPath,
    link: (params: { id: string }) =>
      generatePath(availabilityTimeByIdPath, params),
  },
};
